import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  UNDEFINED_WICKET_BASE_URL,
  UNDEFINED_WICKET_DICTS_URL,
  UNDEFINED_WICKET_V2_URL,
} from './tisa-wicket.errors';
import {ApiModuleConfig} from '@tisa-group/cdk/models';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  TISA_WICKET_DICTS_URL,
  TISA_WICKET_ENTITLEMENTS_API_URL,
  TISA_WICKET_TOKEN,
  TISA_WICKET_URL,
  TISA_WICKET_V2_API_URL,
  WICKET_REFRESH_TOKEN_KEY,
  WICKET_TOKEN_KEY,
} from './tisa-wicket.providers';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {AuthInterceptor} from './auth.interceptor';
import {ApplicationsApiService} from './applications-api/applications-api.service';
import {WicketAgreementsService} from './agreements/agreements.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    ApplicationsApiService,
    WicketAgreementsService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class TisaWicketModule {
  static forRoot({
    // api,
    // dictionariesApi,
    wicketTokenStorageKey,
    wicketRefreshTokenStorageKey,
  }: // v2Api,
  // entitlementsApi,
  WicketApiModuleConfig): ModuleWithProviders<TisaWicketModule> {
    // if (!api) throw UNDEFINED_WICKET_BASE_URL;

    // if (!v2Api) throw UNDEFINED_WICKET_V2_URL;

    // if (!dictionariesApi) throw UNDEFINED_WICKET_DICTS_URL;

    return {
      ngModule: TisaWicketModule,
      providers: [
        // {
        //   provide: TISA_WICKET_URL,
        //   useValue: api,
        // },
        // {
        //   provide: TISA_WICKET_DICTS_URL,
        //   useValue: dictionariesApi,
        // },
        // {provide: TISA_WICKET_V2_API_URL, useValue: v2Api},
        // {provide: TISA_WICKET_ENTITLEMENTS_API_URL, useValue: entitlementsApi},
        {
          provide: WICKET_TOKEN_KEY,
          useValue: wicketTokenStorageKey ?? 'wicketToken',
        },
        {
          provide: WICKET_REFRESH_TOKEN_KEY,
          useValue: wicketRefreshTokenStorageKey ?? 'wicketRefreshToken',
        },
        {
          provide: TISA_WICKET_TOKEN,
          useFactory: (localStorage: Storage) => {
            return () => localStorage.getItem('api_token');
          },
          deps: [LOCAL_STORAGE],
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true,
        },
      ],
    };
  }
}

interface WicketApiModuleConfig extends ApiModuleConfig {
  readonly dictionariesApi: string;
  readonly wicketTokenStorageKey?: string;
  readonly wicketRefreshTokenStorageKey?: string;
  readonly v2Api?: string;
  readonly entitlementsApi?: string;
}
